export default "__VITE_ASSET__vrsFd5fy__"